export default __webpack_public_path__ + "static/media/hexagon-inner-1.7a63547b.svg";